export default __webpack_public_path__ + "static/media/vuesax-linear-timer.d7325cab.svg";